import { AppThunk } from '../../types';
import { IEscrowFileCompleteData } from '../../../types/order/escrow/IEscrowFileCompleteData';
import { IGetUser } from '../../../types/users/IUser';
import { notEmpty } from '../../../ui-toolkit/utilities/notEmpty';
import { getUsers } from '../../usersCollection/allUsers/dispatch';

export const getEscrowFileAndVoidUsersAction =
  (orderId: string, escrowData: IEscrowFileCompleteData): AppThunk =>
  async (dispatch) => {
    try {
      const data = escrowData;
      const manualChecks = data.manualCheckDisbursements;
      if (manualChecks && manualChecks.length > 0) {
        const voidUsers: IGetUser[] = manualChecks
          .map((check) => (check.voiderId ? ({ userType: 'ADMIN', userId: check.voiderId } as IGetUser) : undefined))
          .filter(notEmpty);
        dispatch(getUsers(voidUsers));
      }
    } catch (e) {}
  };
